import {
  DoctorModuleItem,
  PendingConsultationItem
} from '@/store/consultories/types'

export interface ScheduleState {
  filterOpen: boolean
  filter: Filter
  showRequests: boolean
  loadingAllModules: boolean
  doctorModules: Array<DoctorModuleItem>
  pendingConsultations: Array<PendingConsultationItem>
  scheduledConsultations: Array<PendingConsultationItem>
  loadingPendingConsultations: boolean
  loadingScheduledConsultations: boolean
  loadingCancelConsultations: boolean
}

export interface ScheduleEvent {
  id: number
  doctorId: number
  patientId: number
  consultoryId: number
  moduleId: number
  moduleName: string
  consultoryName: string
  patientName: string
  start: string
  end: string
  title: string
  icon: string
  content: string
  status: number
  statusDescription: string
  inObservation: boolean
}
export enum Filter {
  ALL,
  SCHEDULED,
  DONE
}

export interface CancelConsultationReason {
  id: number
  reason: string
  message?: Array<string>
}

export interface CancelConsultationRequest {
  reasonId: number
  hours: number
  eventId: number
  patientId: number
}
